export const DEFAULT_NEWS_ITEMS = [
  {
    id: "default-yms-univers",
    title: "YMS, univers en construction",
    category: "Artiste",
    description: "Portrait, inspirations, studio et direction visuelle autour du projet YMS.",
    media: "/images/yms-full.png",
    mediaType: "image",
    externalUrl: "/artistes",
    buttonLabel: "Découvrir",
    visible: true,
    date: "",
  },
  {
    id: "default-latdior",
    title: "Latdior prend forme",
    category: "Merch",
    description: "La capsule Unlimited Session s'installe entre merch, cover art et culture studio.",
    media: "/images/latdior4.png",
    mediaType: "image",
    externalUrl: "/latdior",
    buttonLabel: "Découvrir",
    visible: true,
    date: "",
  },
];

